
import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const lunchDinnerItems = [
  {
    name: 'حمص باللحمة',
    description: 'حمص كريمي طازج مع قطع اللحم المتبلة والصنوبر',
    price: '28 ريال',
    image: 'https://public.readdy.ai/ai/img_res/f7f964b6c91e90b7f3a299874acac933.jpg'
  },
  {
    name: 'فتوش لبناني',
    description: 'سلطة فتوش طازجة بالخضار الملونة والخبز المحمص',
    price: '22 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20Lebanese%20fattoush%20salad%20with%20colorful%20vegetables%20and%20toasted%20bread%2C%20Middle%20Eastern%20cuisine%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20vibrant%20healthy%20ingredients&width=400&height=300&seq=fattoush1&orientation=landscape'
  },
  {
    name: 'تبولة طازجة',
    description: 'تبولة لبنانية أصيلة بالبقدونس والطماطم والليمون',
    price: '18 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20Lebanese%20tabbouleh%20salad%20with%20parsley%20tomatoes%20and%20lemon%2C%20authentic%20Middle%20Eastern%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20green%20herbs%20abundant&width=400&height=300&seq=tabbouleh1&orientation=landscape'
  },
  {
    name: 'كبسة لحم',
    description: 'كبسة أرز بالتوابل الخاصة مع لحم الضأن الطري',
    price: '45 ريال',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20kabsa%20rice%20with%20tender%20lamb%20meat%20and%20special%20spices%2C%20Saudi%20Arabian%20cuisine%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20aromatic%20golden%20rice&width=400&height=300&seq=kabsa1&orientation=landscape'
  },
  {
    name: 'مندي دجاج',
    description: 'دجاج مندي مدخن مع أرز بسمتي معطر بالتوابل',
    price: '38 ريال',
    image: 'https://readdy.ai/api/search-image?query=Smoked%20mandi%20chicken%20with%20fragrant%20basmati%20rice%20and%20spices%2C%20traditional%20Middle%20Eastern%20main%20course%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20tender%20juicy%20chicken&width=400&height=300&seq=mandi1&orientation=landscape'
  },
  {
    name: 'برياني جمبري',
    description: 'برياني بالأرز البسمتي والجمبري الطازج والتوابل الهندية',
    price: '42 ريال',
    image: 'https://readdy.ai/api/search-image?query=Shrimp%20biryani%20with%20basmati%20rice%20and%20Indian%20spices%2C%20luxury%20seafood%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20aromatic%20colorful%20rice%20dish&width=400&height=300&seq=biryani1&orientation=landscape'
  },
  {
    name: 'سمك مشوي',
    description: 'سمك طازج مشوي مع الليمون والأعشاب الطبيعية',
    price: '48 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20grilled%20fish%20with%20lemon%20and%20natural%20herbs%20on%20elegant%20white%20plate%2C%20seafood%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20perfectly%20cooked%20fillet&width=400&height=300&seq=fish1&orientation=landscape'
  },
  {
    name: 'جمبري مقلي',
    description: 'جمبري طازج مقلي مع البقسماط والتوابل الخاصة',
    price: '35 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20fried%20shrimp%20with%20breadcrumbs%20and%20special%20spices%2C%20luxury%20seafood%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20golden%20crispy%20coating&width=400&height=300&seq=shrimp1&orientation=landscape'
  },
  {
    name: 'معكرونة أرابياتا',
    description: 'معكرونة إيطالية بصلصة الطماطم الحارة والأعشاب',
    price: '32 ريال',
    image: 'https://readdy.ai/api/search-image?query=Italian%20arrabbiata%20pasta%20with%20spicy%20tomato%20sauce%20and%20herbs%2C%20authentic%20Italian%20cuisine%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20al%20dente%20pasta&width=400&height=300&seq=pasta1&orientation=landscape'
  },
  {
    name: 'بيتزا مارغريتا',
    description: 'بيتزا إيطالية كلاسيكية بالطماطم والموتزاريلا والريحان',
    price: '36 ريال',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Italian%20margherita%20pizza%20with%20tomatoes%20mozzarella%20and%20basil%2C%20authentic%20Italian%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20thin%20crispy%20crust&width=400&height=300&seq=pizza1&orientation=landscape'
  },
  {
    name: 'سلطة سيزر',
    description: 'سلطة سيزر كلاسيكية بالخس والدجاج وجبن البارميزان',
    price: '26 ريال',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Caesar%20salad%20with%20lettuce%20chicken%20and%20parmesan%20cheese%2C%20elegant%20restaurant%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20fresh%20crispy%20greens&width=400&height=300&seq=caesar1&orientation=landscape'
  },
  {
    name: 'تيراميسو',
    description: 'حلوى تيراميسو إيطالية أصيلة بالقهوة والمسكربون',
    price: '24 ريال',
    image: 'https://readdy.ai/api/search-image?query=Authentic%20Italian%20tiramisu%20dessert%20with%20coffee%20and%20mascarpone%2C%20elegant%20dessert%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20layered%20creamy%20texture&width=400&height=300&seq=tiramisu1&orientation=landscape'
  }
];

export default function LunchDinner() {
  const [scrolled, setScrolled] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-r from-orange-600 to-orange-700">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
            وجبات الغداء والعشاء
          </h1>
          <p className="text-xl text-orange-100 max-w-3xl mx-auto mb-8">
            تذوق أشهى الأطباق المحلية والعالمية المحضرة بأفضل المكونات
          </p>
          <div className="inline-flex items-center gap-3 bg-white/20 rounded-full px-6 py-3 text-white">
            <i className="ri-time-line text-2xl"></i>
            <span className="text-lg font-semibold">يوميًا من 12:00 م - 11:00 م</span>
          </div>
        </div>
      </section>

      {/* Menu Items */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {lunchDinnerItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-2xl font-bold text-orange-600">
                      {item.price}
                    </span>
                  </div>
                  <p className="text-base text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-16">
            <div className="inline-block bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center gap-4 justify-center mb-4">
                <i className="ri-information-line text-3xl text-orange-600"></i>
                <h3 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  معلومات إضافية
                </h3>
              </div>
              <div className="space-y-3 text-gray-700">
                <p className="text-lg"><strong>الخدمة:</strong> متوفرة في المطعم وخدمة الغرف</p>
                <p className="text-lg"><strong>الحجز:</strong> يُنصح بالحجز المسبق خاصة في المساء</p>
                <p className="text-lg"><strong>الموقع:</strong> الطابق الأرضي - فندق فوكاتشيا</p>
                <p className="text-sm text-orange-600 font-semibold mt-4">* الأسعار للعرض فقط وقابلة للتغيير</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
